import ModalSvcContext from 'src/shared/services/modal/modal.context';
import ModalService from 'src/shared/services/modal/modal.service';
import APP_MODALS from 'src/static/enums/app.modals';
import { useContext, useRef } from 'react';

export default function ViewMemeModal() {
	const modalRef = useRef<HTMLDivElement>(null);
	const modalContentRef = useRef<HTMLDivElement>(null);
	const modalSvc = useContext<ModalService>(ModalSvcContext);

	const modalSvcData = modalSvc.getModals().value[0].data || {};

	const { imgUrl } = modalSvcData || {};

	const closeRejectionModal = () => {
		modalSvc.closeModal(APP_MODALS.VIEW_MEME_MODAL);
	};

	return (
		<main
			className="fixed inset-0 bg-black cursor-pointer bg-opacity-50 pointer-events-auto flex items-center justify-center z-[200]"
			tabIndex={-1}
			ref={modalRef}
			onClick={closeRejectionModal}
		>
			<div
				ref={modalContentRef}
				className="w-[343px]  rounded-lg bg-white dark:bg-dark-800 min-h-[200px] max-h-fit md:w-[470px]"
			>
				<div className="  p-[20px] rounded-lg w-full">
					{/* Header */}
					<div className="flex justify-between items-center ">
						<h2 className="text-[24px] font-bold leading-[36px] dark:text-white invisible">
							Reject Submission
						</h2>
						<button
							onClick={closeRejectionModal}
							className="text-gray-500 hover:text-gray-700 dark:text-white text-2xl flex items-center justify-center rounded-[4px] size-5 hover:bg-light-700 hover:p-2 dark:hover:bg-dark-700"
						>
							<i className="fa-solid fa-xmark text-sm"></i>
						</button>
					</div>
					{/* img con */}
					<div>{imgUrl && <img src={imgUrl} className="size-full" alt="meme" />}</div>
				</div>
			</div>
		</main>
	);
}
